/* eslint-disable banned-modules */
'use strict';

import $ from 'jquery';
import BaseView from '@/classes/base.view';
import Header from '@/blocks/layout/b-header/index';
import Footer from '@/blocks/layout/b-footer/index';
import Loader from '@/blocks/layout/b-loader/index';
import Login from '@/blocks/pages/b-login/view';
import Authorization from '@/blocks/pages/b-authorization/index';
import template from './template.ejs';
import './style.less';

const Layout = () => {
	const view = BaseView.extend({

		template,

		el: 'body',

		initialize() {
			this.is_b2c = STATE.checkSiteType('B2C');
			if (!this.checkAuthorization()) {
				this.render();
				this.drawLogin();
				new Loader();
			} else {
				new Loader();
			}
			STATE.layout = this;
		},

		drawLogin() {
			if (STATE.loginView == null) {
				STATE.loginView = new Login();
			}
		},

		renderHeader(options = {}) {
			if (_.has(options, 'balanceInfo')) {
				this.lastBalanceInfo = options.balanceInfo;
			}

			if (this.header != null) {
				this.header.render({ balanceInfo: this.lastBalanceInfo });
				this.header.initReactComponents();
				this.rebindBreadcrumbs();
				return;
			}

			this.header = new Header({
				balanceInfo: this.lastBalanceInfo,
			});
			this.rebindBreadcrumbs();
		},

		rebindBreadcrumbs() {
			const breadcrumbs = STATE.router && STATE.router.breadcrumbs;

			if (breadcrumbs == null || !_.isFunction(breadcrumbs.remount)) {
				return;
			}

			breadcrumbs.remount();
			// Remount recreates DOM; hide until a booking route handler shows breadcrumbs.
			breadcrumbs.$el.hide();
		},

		isHeaderIntact() {
			const $headerContainer = $('.l-layout__header');
			const hasHeaderBar = $headerContainer.children('.b-header').length > 0;
			const hasLanguageWidget = $headerContainer
				.find('.b-header__info-language .p-login__header-language').length > 0;

			return hasHeaderBar && hasLanguageWidget;
		},

		ensureHeaderPresent() {
			if (!this.isHeaderIntact()) {
				this.renderHeader();
			}
		},

		renderFooter() {
			if (!this.footer) {
				this.footer = new Footer();
			}
		},

		checkAuthorization() {
			if (window.location.href.includes('/authorization/page/')) {
				this.$el.append(new Authorization());
				return true;
			}
			return false;
		},

	});

	new view();
};

export default Layout;
